/*
 * @Description: 
 * @Author: 诺
 * @Date: 2022-02-22 15:39:01
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-21 15:46:27
 */

import md5 from 'md5'
class Sign {
  constructor() {
    this.version = "1.0.0"
    this.timestamp = new Date().getTime()
    // this.appKey = '48BAE7DD3F5646A98225BE5FB39961DD'
    // this.appSecret = '9C8EA1E9C6374C16AB59B60D268DF29F'
    if (process.env.VUE_APP_SERVE_ENV === "prod"){
      this.appKey = '9B8D4220AFD94990B702705C3DDAF570'
      this.appSecret = 'ADEA1F21DDCF4363B424C163BD6A985E'
      
      this.signKey = 'MVQPAHD56L82EIT4TMV86P5RDOSJ398P'
      this.signSecret = 'LBYKKWULMJSPIY47Y7H2C51VAS91TGPR'
    }else{
      this.appKey = 'B7ED10B3CFEF4EC699EA16D55F08A1C3'
      this.appSecret = 'E1E79FD7B5714AD493BFCA540C430ABB'
      
      this.signKey = '0VUBJAO1EGS5X1C079609Z4VFDRUNWGD'
      this.signSecret = '8G1RDQV38FM3PF3TLDNFYBSA2V66SLJ5'
    }
  }


  createSign(p = '') {

    if (p.indexOf('?') > -1) p = p.split('?')[0]

    const signObj = { timestamp: this.timestamp, version: this.version, path: p }
    console.log(signObj)
    let signObjSort = {}
    Object.keys(signObj).sort().forEach((key) => {
      signObjSort[key] = signObj[key];
    });

    let signObjStr = ''
    for (const key in signObjSort) {
      signObjStr += key + signObjSort[key]
    }
    const signStr = md5(signObjStr + this.appSecret).toUpperCase()
    // console.log(signStr);
    return signStr
  }
  
  paySign(p = '') {

    if (p.indexOf('?') > -1) p = p.split('?')[0]

    const signObj = { timestamp: this.timestamp, version: this.version, path: p }
    console.log(signObj)
    let signObjSort = {}
    Object.keys(signObj).sort().forEach((key) => {
      signObjSort[key] = signObj[key];
    });

    let signObjStr = ''
    for (const key in signObjSort) {
      signObjStr += key + signObjSort[key]
    }
    const signStr = md5(signObjStr + this.signSecret).toUpperCase()
    // console.log(signStr);
    return signStr
  }
}

export default Sign
